import { Gender, IPerson, PersonExtended } from '@lib/user';

/**
 * One option of the "Bedarfsträger" list filter, as delivered by
 * `GET /purchase-requisition/consumers/selectable`.
 *
 * Deliberately lean — identity plus the parts of the displayed label. The backend derives the set
 * from the same visibility predicate as the list itself (EPROC-11749).
 */
export interface ISelectableConsumer {
    id: string;
    firstName: string;
    surName: string;
    title: string;
    active: boolean;
}

/**
 * Lifts a lookup option into the `PersonExtended` the typeahead expects. Gender and academic title
 * are not part of the lean payload and are not used by the filter.
 */
export function selectableConsumerToPerson(consumer: ISelectableConsumer): PersonExtended {
    const person: IPerson = {
        id: consumer.id,
        name: consumer.surName,
        firstName: consumer.firstName,
        surName: consumer.surName,
        gender: Gender.UNKNOWN,
        title: consumer.title,
        academicTitle: '',
        active: consumer.active,
    };

    return new PersonExtended(person);
}
